// const jQuery = require( "jquery" );
import "../styles/app.scss";

import "../node_modules/@splidejs/splide/dist/css/splide.min.css";
// import Player from "@vimeo/player";
import { splitLines } from "./splitLines.js";

import Splide from "@splidejs/splide";
import { toggle } from "./toggle/toggle.js";
// import { cookiePolicy } from "./cookiepolicy/cookiepolicy.js";
import { multilevel } from "./multilevel-nav/multilevel-nav.js";
// import { windowheight } from "./windowheight/windowheight.js";
import { closeAllPopups } from "./closeAllPopups.js";
import { cloudTranslate } from "./cloudTranslate.js";
//import { xmllib } from "./xml-lib/xml-lib.js";
import { inheritLinks } from "./inherit-links/inherit-links.js";
import { isAnimation } from "./animation.js";
import { blogGrid } from "./blogGrid.js";
import { Search } from "./Search.js";

import lib from "./js-lib/lib";
import Lightbox from "./Modules/Lightbox";
import Wistia from "./Modules/Wistia";
import ImageVideoSlider from "./Molecules/ImageVideoSlider";

import Careers from "./Careers";

Search.init();

if (document.querySelector(".masonry-root")) {
  blogGrid();
}

inheritLinks();
isAnimation();
let primaryVideoHasLoaded = false;

//* 28 JUL 2022 *//
//**  PLEASE NOTE: Javascript Modal was added AFTER go-live. **//
//** js-lib and the App.JS model have been retroimplemented to this site */
window.state = {
  theme: {
    name: "edsa-2022",
    current: "light",
    opt: ["light", "dark"],
    body: true,
  },
  eco: {
    name: "eco",
    current: "disabled",
    opt: ["disabled", "enabled"],
    body: false,
  },
  videos: [],
  lightboxes: [],
};

window.App = {
  load_cache: (data = false) => {},
  global_scope: (data = false) => {},
  scope: (data = false) => {
    Wistia.render(state);
    //ImageVideoSlider.scope(state);
    Lightbox.render(state);

    Careers.type(state);
    Careers.idtourl(state);
  },
  render: (data = false) => {},
};

// Wait for the DOM to load
window.onload = function () {
  App.load_cache();
  App.global_scope();
  App.scope();
};

// Page Down
document.querySelectorAll(".ico-arrow-page-down").forEach((elem) => {
  elem.addEventListener("click", () => {
    window.scroll({
      top: window.innerHeight,
      left: 0,
      behavior: "smooth",
    });
  });
});

const splide = [];
const toggleButton = [];
const Autoplay = [];
const splideLeft = [];
const splideRight = [];
const siblings = (n) => [...n.parentElement.children].filter((c) => c != n); // Select Sibling with Class
const siteWidth = window.innerWidth;

let bannerState = document.querySelector(
  "article > .header-block-1:first-child, article > .project-insight-header-block-12:first-child, article > .article-block-21-0:first-child, .page-404-block"
);

if (bannerState) {
  document.querySelector("header.header").classList.add("dark-mode");
  document.querySelector("header.header").classList.add("has-header");
  document.querySelector("header.header").classList.add("transparent-mode");

  function nonTransparentMode() {
    document
      .querySelector("header.header")
      .classList.remove("transparent-mode");
    document.querySelector("header.header").classList.remove("dark-mode");
    if (document.querySelector(".header-block-1:first-child")) {
      document
        .querySelector(".header-block-1:first-child")
        .classList.add("rm-from-vp");
    }
  }

  function transparentMode() {
    document.querySelector("header.header").classList.add("transparent-mode");
    document.querySelector("header.header").classList.add("dark-mode");
    if (document.querySelector(".header-block-1:first-child")) {
      document
        .querySelector(".header-block-1:first-child")
        .classList.remove("rm-from-vp");
    }
  }

  document.addEventListener("scroll", () => {
    if (window.scrollY >= bannerState.offsetHeight) {
      nonTransparentMode();
    } else {
      transparentMode();
    }
    // Due to how the block breaks on mobile we need this to happen sooner
    if (siteWidth < 576) {
      if (window.scrollY >= bannerState.offsetHeight / 2) {
        nonTransparentMode();
      } else {
        transparentMode();
      }
    }
  });
}

/**** Wistia Implementation ****/
// Initinalise Wistia

// let videos = document.querySelectorAll("[data-vid]");

// // Create new player Array
// const player = [];
// let newElem = "";

// let timerA = 0;

// // Create new Elements for Wistia
// videos.forEach((video, i) => {
//   setTimeout(() => {
//     newElem = document.createElement("div");
//     newElem.className = "wistia_embed wistia_async_" + video.dataset.vid;
//     newElem.style.height = "100%";
//     newElem.style.width = "100%";
//     video.appendChild(newElem);
//     player[i] = newElem;
//   }, timerA);

//   timerA = timerA + 1000;
// });

// let timer = 0;

// Create new Elements for Wistia
// videos.forEach((videox, i) => {
//   setTimeout(() => {
//     window._wq = window._wq || [];
//     _wq.push({
//       id: videox.dataset.vid,
//       options: {
//         fitStrategy: "cover",
//         playButton: false,
//         controlsVisibleOnLoad: false,
//         fullscreenButton: false,
//         playPauseNotifier: false,
//         settingsControl: false,
//       },
//       onReady: function (video) {
//         //player[i] = video;

//         video.muted = true;

//         if (i == 0) {
//           primaryVideoHasLoaded = true;
//           Autoplay[0].play();
//         }

//         if (i !== 0) {
//           video.pause();
//         }
//       },
//     });
//   }, timer);

//   timer = timer + 1000;
// });

// let isVideo = document.querySelectorAll(".for-d-lightbox video");

// isVideo.forEach((vid, i) => {
//   vid.currentTime = 0;
//   vid.muted = true;
//   vid.pause();
// });

/* Handle WISTIA play button */
// document
//   .querySelectorAll(".video-controls-video .splide__play")
//   .forEach((elem, i) => {
//     elem.addEventListener("click", () => {
//       elem.closest(".video-container");

//       // Check for NON EXISTENT video
//       if (!elem.closest(".video-container")) {
//         return true;
//       }
//       if (!elem.closest(".video-container").querySelector(".vid")) {
//         return true;
//       }
//       if (!elem.closest(".video-container").querySelector(".vid").dataset.vid) {
//         return true;
//       }

//       // RETRIEVE video ID
//       let vidid = elem.closest(".video-container").querySelector(".vid")
//         .dataset.vid;

//       //
//       _wq.push({
//         id: vidid,
//         onReady: function (video) {
//           video.play();
//           console.log("Play 6");
//           video.muted = false;
//         },
//       });
//     });
//   });

/* Handle WISTIA pause button */
// document
//   .querySelectorAll(".video-controls-video .splide__pause")
//   .forEach((elem, i) => {
//     //elem = elemx.querySelector('.splide__pause');

//     elem.addEventListener("click", () => {
//       elem.closest(".video-container");

//       // Check for NON EXISTENT video
//       if (!elem.closest(".video-container")) {
//         return true;
//       }
//       if (!elem.closest(".video-container").querySelector(".vid")) {
//         return true;
//       }
//       if (!elem.closest(".video-container").querySelector(".vid").dataset.vid) {
//         return true;
//       }

//       // RETRIEVE video ID
//       let vidid = elem.closest(".video-container").querySelector(".vid")
//         .dataset.vid;

//       //
//       _wq.push({
//         id: vidid,
//         onReady: function (video) {
//           video.pause();
//           video.muted = false;
//           // elemx.classList.add('video-paused');
//         },
//       });
//     });
//   });

/* Handle WISTIA initial play on LIGHTBOX (OR Wistia Click Directly On Video) */
// document.querySelectorAll(".video-container .vid").forEach((elem, i) => {
//   //elem = elemx.querySelector('.splide__pause');

//   elem.addEventListener("click", () => {
//     let vidContainer = elem.closest(".video-container");

//     // Check for NON EXISTENT video
//     if (!elem.closest(".video-container")) {
//       return true;
//     }
//     if (!elem.closest(".video-container").querySelector(".vid")) {
//       return true;
//     }
//     if (!elem.closest(".video-container").querySelector(".vid").dataset.vid) {
//       return true;
//     }

//     // RETRIEVE video ID
//     let vidid = elem.closest(".video-container").querySelector(".vid")
//       .dataset.vid;

//     vidContainer
//       .querySelector(".video-controls-video")
//       .classList.remove("video-paused");
//     //elem.querySelector('.video-controls-video').classList.remove('video-paused');

//     _wq.push({
//       id: vidid,
//       onReady: function (video) {
//         video.play();
//         console.log("Play 7");
//         video.muted = false;
//         // elemx.classList.add('video-paused');
//       },
//     });
//   });
// });

/* Handle WISTIA initial play on LIGHTBOX */
// document.querySelectorAll(".d-lightbox .overlay").forEach((elem, i) => {
//   //elem = elemx.querySelector('.splide__pause');

//   elem.addEventListener("click", () => {
//     let vidContainer =
//       elem.parentNode.parentNode.parentNode.querySelector(".video-container");

//     console.log(vidContainer);

//     // Check for NON EXISTENT video
//     if (!vidContainer) {
//       return true;
//     }
//     if (!vidContainer.querySelector(".vid")) {
//       return true;
//     }
//     if (!vidContainer.querySelector(".vid").dataset.vid) {
//       return true;
//     }

//     // RETRIEVE video ID
//     let vidid = vidContainer.querySelector(".vid").dataset.vid;

//     vidContainer
//       .querySelector(".video-controls-video")
//       .classList.remove("video-paused");

//     vidContainer.classList.remove("video-paused");

//     //elem.querySelector('.video-controls-video').classList.remove('video-paused');

//     //
//     _wq.push({
//       id: vidid,
//       onReady: function (video) {
//         video.pause();
//         video.muted = true;
//         // elemx.classList.add('video-paused');
//       },
//     });
//   });
// });

// Add Splide Slider example (Binds to .splide)
document.querySelectorAll(".splide-slider").forEach((elem, i) => {
  elem.dataset.splideid = i;

  splide[i] = new Splide(elem, {
    type: "loop",
    perPage: 1,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    interval: "6000",
    speed: "800",
  });

  splide[i].on("mounted", function () {});
  splide[i].mount();

  // Slider is Playing
  splide[i].on("autoplay:play", function () {
    elem.classList.remove("slider-paused");
    elem.classList.add("slider-playing");
  });

  // Slider is Paused
  splide[i].on("autoplay:pause", function () {
    elem.classList.remove("slider-playing");
    elem.classList.add("slider-paused");
  });

  // Slider Navigation
  splideLeft[i] = elem.querySelector(".splide-controls-left");
  splideRight[i] = elem.querySelector(".splide-controls-right");
  splideRight[i].addEventListener("click", () => {
    splide[i].go(">");
  });
  splideLeft[i].addEventListener("click", () => {
    splide[i].go("<");
  });

  // Play / Pause Control
  toggleButton[i] = elem.querySelector(".splide-controls-play-pause");
  Autoplay[i] = splide[i].Components.Autoplay;
  Autoplay[i].play();

  if (toggleButton[i]) {
    toggleButton[i].addEventListener("click", () => {
      if (Autoplay[i].isPaused()) {
        //Autoplay[i].play();
        console.log("Play 8");
        toggleButton[i].classList.add("playing");
      } else {
        Autoplay[i].pause();
        toggleButton[i].classList.remove("playing");
      }
    });
  }

  // When splide is mounted
  setTimeout(() => {
    //let all = splide[i].Components.Elements.slides;
    let all = document.querySelectorAll(
      ".header-block-1 .splide li.splide__slide video"
    );

    if (all.length > 0) {
      let current = splide[i].Components.Elements.slides[splide[i].index];

      if (current.querySelector("[data-vid]")) {
        let relatedvideo = document.querySelectorAll(
          "[data-vid='" +
            current.querySelector("[data-vid]").dataset.vid +
            "'] video"
        );

        // all.forEach((elem, i) => {
        //   elem.pause();
        //   elem.currentTime = 0;
        // });

        _wq.push({
          id: current.querySelector("[data-vid]").dataset.vid,
          onReady: function (video) {
            video.play();
            video.muted = false;
          },
        });

        // if (current.classList.contains("is-active")) {

        //   relatedvideo.forEach((vid, i) => {

        //     vid.currentTime = 0;
        //     vid.muted = true;
        //     vid.play();
        //   });
        // }
      }
    }
  }, 1500);

  // When splide has moved
  splide[i].on("move", function () {
    // let all = splide[i].Components.Elements.slides;
    let all = document.querySelectorAll(
      ".header-block-1 .splide li.splide__slide video"
    );

    if (all.length > 0) {
      let current = splide[i].Components.Elements.slides[splide[i].index];

      if (current.querySelector("[data-vid]")) {
        let relatedvideo = document.querySelectorAll(
          "[data-vid='" +
            current.querySelector("[data-vid]").dataset.vid +
            "'] video"
        );

        all.forEach((elem, i) => {
          elem.pause();
          elem.currentTime = 0;
        });

        console.log(relatedvideo);

        relatedvideo.forEach((vid, i) => {
          setTimeout(() => {
            vid.currentTime = 0;

            if (typeof vid.play !== "undefined") {
              vid.play();
            }
          }, 100);
        });
      }
    }

    if (elem.querySelector(".progress")) {
      elem.querySelector(".progress").style.width =
        ((splide[i].index + 1) / splide[i].length) * 100 + "%";
    }
  });
});

const isIntersecting = () => {
  let callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Play splide if in view

        let hasSlider = entry.target.querySelectorAll(".splide");
        if (hasSlider) {
          hasSlider.forEach((slide, i) => {
            if (slide.dataset.splideid) {
              if (Autoplay[slide.dataset.splideid]) {
                if (primaryVideoHasLoaded) {
                  Autoplay[slide.dataset.splideid].play();
                }
              }
            }
          });
        }

        let isVideo = entry.target.querySelectorAll(
          ".image-video-slider video"
        );

        isVideo.forEach((vid, i) => {
          vid.currentTime = 0;
        });

        entry.target.classList.add("is-intersecting");
      } else {
        let isLightbox = entry.target.querySelector(".for-d-lightbox");

        // Play splide if in view
        let hasSlider = entry.target.querySelectorAll(".splide");
        if (hasSlider) {
          hasSlider.forEach((slide, i) => {
            if (slide.dataset.splideid) {
              if (Autoplay[slide.dataset.splideid]) {
                Autoplay[slide.dataset.splideid].pause();
              }
            }
          });
        }

        let isVideo = entry.target.querySelectorAll(".for-d-lightbox video");

        isVideo.forEach((vid, i) => {
          vid.currentTime = 0;
        });

        entry.target.classList.remove("is-intersecting");
      }
    });
  };

  let ioObserver = new IntersectionObserver(callback, {
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: 0,
  });

  let elements = document.querySelectorAll("[intersection]"); // Select all elements

  // Add all elements to observer
  elements.forEach((element) => {
    ioObserver.observe(element);
  });
};

isIntersecting();

setTimeout(() => {
  splitLines(document.querySelectorAll(".fs-85, .indent-text"));
}, 20);

setTimeout(() => {
  const langList = document.querySelectorAll("#lang-list li");

  const langData = cloudTranslate.screen(
    document.querySelectorAll("[translate] *")
  );

  const params = new URLSearchParams(window.location.search);

  if (params.has("ctlang")) {
    loadLangEffect();
    cloudTranslate.init(params.get("ctlang"), langData, window.location.href);
    setNewLangParam();
    setNewLangParam(params.get("ctlang"));
  }

  langList.forEach((elem) => {
    elem.addEventListener("click", () => {
      loadLangEffect();
      window.scrollTo(0, 0);
      params.set("ctlang", elem.dataset.lang);

      params.toString();
      window.history.replaceState(
        {},
        "",
        `${location.pathname}?${params.toString()}`
      );

      setNewLangParam(elem.dataset.lang);

      cloudTranslate.init(elem.dataset.lang, langData, window.location.href);

      closeAllPopups();

      document.querySelectorAll(".wpml-ls-link").forEach((elem) => {
        elem.href = elem.href.split("?")[0];
      });
    });
  });

  document.querySelectorAll(".wpml-ls-link").forEach((elem) => {
    elem.href = elem.href.split("?")[0];
  });

  function setNewLangParam(lang) {
    /* Set Url for New Language */
    let ahrefs = document.querySelectorAll("a:not(.ico-navicon)");

    ahrefs.forEach((ahref) => {
      if (!ahref.href.includes("#")) {
        let newUrl = ahref.href;

        if (ahref.href.includes("?")) {
          newUrl = newUrl.split("?")[0];
        }

        newUrl = newUrl + "?ctlang=" + lang;
        ahref.href = newUrl;
      }
    });
  }

  var elemental = require("./elem/elem.js");
  // let CookiesEuBanner = new cookiePolicy();
  let Multilevel = new multilevel(".menu");
  let MultilevelFooter = new multilevel(".atom-menu-main-footer .nav-main");

  // Set up Toggles
  let toggleNavicon = new toggle(
    "data-linknavicon",
    "data-targetnavicon",
    "active",
    ["dark-mode"],
    3
  );

  // Set up Toggles (Language)
  let toggleLanguage = new toggle(
    "data-linklanguage",
    "data-targetlanguage",
    "active"
  );

  document.querySelectorAll(".ico-cross, .overlay").forEach((elem) => {
    elem.addEventListener("click", () => {
      closeAllPopups();
    });
  });

 const link = (a, b) => {

    let c = document.querySelectorAll(a);
    let d = document.getElementById(b);

    console.log(d);


    c.forEach((e) => {

      e.addEventListener("click", (f) => {

      console.log(d);

        f.preventDefault();
        let status = d.classList.contains("active") ? true : false;
        closeAllPopups("link-a-" + b);

        c.forEach((nlL) => {
          document.querySelector("body").classList.remove("void-scroll");
          d.classList.remove("active");
          e.classList.remove("active");
        });

        if (status) {
          document.querySelector("body").classList.remove("void-scroll");
          d.classList.remove("active");
          e.classList.remove("active");
        } else {
          document.querySelector("body").classList.add("void-scroll");
          d.classList.add("active");
          e.classList.add("active");
        }
      });
    });
  };

  link('a[href="#newsletter"]', "pop-newsletter");
  link('a[href="#cigna"]', "pop-cigna");
  link('a[href="#selectlanguage"]', "pop-languages");
  link('a[href="#search"]', "pop-search");
  link('a[href="#wechatpopup"]', "pop-wechat");

  document.querySelector('a[href="#search"]').addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelector("#search").focus();
  });

  var siblings = (n) => [...n.parentElement.children].filter((c) => c != n); // Select Sibling with Class

  // Desktop Lightbox Script
  // const lightbox = (a) => {
  //   let elems = document.querySelectorAll(a);

  //   elems.forEach((elem) => {
  //     let hasSlider = elem.parentNode.querySelector(".d-lightbox .splide");

  //     let hasVideo = elem.querySelector(".video-foreground");

  //     if (hasVideo) {
  //       let offset = hasVideo.getBoundingClientRect();
  //       hasVideo.style.top = offset.top + "px";
  //       hasVideo.style.left = offset.left + "px";

  //       document.addEventListener("scroll", function (e) {
  //         let offset = hasVideo.getBoundingClientRect();
  //         hasVideo.style.top = offset.top + "px";
  //         hasVideo.style.left = offset.left + "px";
  //       });
  //     }

  //     let hasOverlay = elem.parentNode.querySelector(".d-lightbox .overlay");

  //     let playPause = elem.parentNode.querySelector(".video-controls-video");

  //     let muteUnmute = elem.parentNode.querySelector(".video-controls-mute");

  //     let openVideoLightbox = elem.parentNode.querySelector(
  //       ".video-controls-lightbox"
  //     );

  //     if (hasSlider) {
  //       Autoplay[hasSlider.dataset.splideid].pause(); // Pause all sliders in lightbox by default

  //       if (hasOverlay) {
  //         hasOverlay.addEventListener("click", (e) => {
  //           Autoplay[hasSlider.dataset.splideid].pause();
  //         });
  //       }
  //     }

  //     if (hasVideo && hasOverlay) {
  //       hasOverlay.addEventListener("click", (e) => {
  //         let vid = hasVideo.querySelector(".vid");
  //         //player[vid.dataset.vimeoid].setVolume(0);
  //         playPause.classList.remove("video-paused");
  //       });
  //     }

  //     if (openVideoLightbox) {
  //       openVideoLightbox.addEventListener("click", (e) => {
  //         let vid = hasVideo.querySelector(".vid");
  //         // player[vid.dataset.vimeoid].play();
  //         // player[vid.dataset.vimeoid].setVolume(1);
  //       });
  //     }

  //     elem.addEventListener("click", (e) => {
  //       closeAllPopups();

  //       elem.classList.add("active");
  //       elem.parentNode.querySelector(".d-lightbox").classList.add("active");
  //       hasSlider = elem.parentNode.querySelector(".d-lightbox .splide");
  //       if (hasSlider) {
  //         Autoplay[hasSlider.dataset.splideid].play();
  //         console.log("Play 5");
  //       }
  //     });

  //     if (hasVideo && playPause) {
  //       playPause.addEventListener("click", (e) => {
  //         let vid = hasVideo.querySelector(".vid");
  //         if (playPause.classList.contains("video-paused")) {
  //           playPause.classList.remove("video-paused");
  //           //player[vid.dataset.vimeoid].play();
  //         } else {
  //           playPause.classList.add("video-paused");
  //           //player[vid.dataset.vimeoid].pause();
  //         }
  //       });
  //     }

  //     if (hasVideo && muteUnmute) {
  //       muteUnmute.addEventListener("click", (e) => {
  //         let vid = hasVideo.querySelector(".vid");
  //         if (muteUnmute.classList.contains("video-muted")) {
  //           muteUnmute.classList.remove("video-muted");
  //           //player[vid.dataset.vimeoid].setVolume(1);
  //         } else {
  //           muteUnmute.classList.add("video-muted");
  //           //player[vid.dataset.vimeoid].setVolume(0);
  //         }
  //       });
  //     }
  //   });
  // };

  // lightbox(".for-d-lightbox");

  const renderGForm = () => {
    const gFormConfiguration = () => {
      const items = document.querySelectorAll(
        ".atom-gform .gfield:not(.hidden_label)"
      );

      items.forEach((item) => {
        item.insertBefore(
          item.querySelector("input, textarea"),
          item.childNodes[0]
        );
        if (item.querySelector(".ginput_container")) {
          item.querySelector(".ginput_container").remove();
        }
      });
    };

    gFormConfiguration();

    const gForm = document.querySelectorAll(".atom-gform");

    // Manage Submit Button
    gForm.forEach((elem) => {
      let dom = new DOMParser().parseFromString(
        '<span data-type="icon" data-temp="ico-plus.twig" class="ico-frame is-red ico-plus"><span class="screen-reader-text">Up</span></span>',
        "text/html"
      );
      let footer = elem.querySelector(".gform_footer.top_label");
      let submit = elem.querySelector('input[type="submit"]');
      footer.classList.add("a");
      let new_element = dom.body.firstElementChild;
      footer.appendChild(new_element);

      submit.addEventListener("click", () => {
        setTimeout(() => {
          let footer = elem.querySelector(".gform_footer.top_label");
          footer.appendChild(new_element);
          renderGForm();
        }, 2000);
      });
    });
  };

  renderGForm();

  function loadLangEffect() {
    let screen = document.getElementById("load-translate");

    screen.classList.add("active");

    let progress = screen.querySelector(".progress");

    setTimeout(() => {
      progress.style.width = "20%";
    }, 300);

    setTimeout(() => {
      progress.style.width = "30%";
    }, 540);

    setTimeout(() => {
      progress.style.width = "50%";
    }, 1000);

    setTimeout(() => {
      progress.style.width = "70%";
    }, 1500);

    setTimeout(() => {
      progress.style.width = "74%";
    }, 1600);

    setTimeout(() => {
      progress.style.width = "78%";
    }, 1700);

    setTimeout(() => {
      progress.style.width = "88%";
    }, 1900);

    setTimeout(() => {
      progress.style.width = "99%";
    }, 2900);

    // setTimeout(() => {
    //   screen.classList.remove("active");
    // }, 3000);
  }
}, 40);

// Intersection

/* Accordion Script */
var accItem = document.querySelectorAll(".accordion .item");

accItem.forEach((item) => {
  item.classList.remove("open");
  item.classList.add("close");
});

var accHD = document.querySelectorAll(".accordion .title");

accHD.forEach((elem, i) => {
  accHD[i].addEventListener("click", toggleAccordion, false);
});

function toggleAccordion() {
  var itemClass = this.parentNode;

  if (itemClass.classList.contains("open")) {
    this.parentNode.classList.remove("close");
    this.parentNode.classList.remove("open");

    return true;
  }
  accItem.forEach((elem, i) => {
    accItem[i].classList.remove("open");
    accItem[i].classList.add("close");
  });
  if (itemClass.classList.contains("close")) {
    this.parentNode.classList.remove("close");
    this.parentNode.classList.add("open");
  }
}

// function testImage(URL) {
//   var tester=new Image();
//   tester.onload=imageFound;
//   tester.onerror=imageNotFound;
//   tester.src=URL;
// }

/* Image Error Script */
if (window.location.toString().includes(".local")) {
  document.querySelectorAll("img").forEach((elem) => {
    elem.addEventListener("error", () => {
      elem.src = "https://via.placeholder.com/1000";
      console.log("img has error");
    });
  });
}

//testImage(elem.src);
// function imageFound() {

// }

// function imageNotFound() {
//   elem.src = "https://via.placeholder.com/1000";
// }

document.addEventListener("DOMContentLoaded", () => {
  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  };
  window.addEventListener("resize", appHeight);
  appHeight();
});

/* Translation Extension for All Pages */

let langlist = [
  // "af",
  // "ga",
  // "sq",
  // "it",
  "ar",
  "ja",
  // "az",
  // "kn",
  // "eu",
  // "ko",
  // "bn",
  // "la",
  // "be",
  // "lv",
  // "bg",
  // "lt",
  // "ca",
  // "mk",
  //"zh-CH",
  // "ms",
  //"zh-TW",
  // "mt",
  // "hr",
  // "no",
  // "cs",
  // "fa",
  // "da",
  // "pl",
  // "nl",
  // "pt",
  // "da",
  // "pl",
  // "nl",
  // "pt",
  // "en",
  "ro",
  // "eo",
  // "ru",
  // "et",
  // "sr",
  // "tl",
  // "sk",
  // "fi",
  // "sl",
  "fr",
  //"es",
  // "gl",
  // "sw",
  // "ka",
  // "sv",
  "de",
  // "ta",
  // "el",
  // "te",
  // "gu",
  // "th",
  // "ht",
  // "tr",
  // "iw",
  // "uk",
  // "hi",
  // "ur",
  // "hu",
  // "vi",
  // "is",
  // "cy",
  // "id",
  // "yi",
];

// langlist = ["ro"];
let pagelist = [
  "",
  "the-firm",
  "the-firm/the-team",
  "the-firm/legacy",
  "the-firm/edsa-impact",
  "portfolio",
  "expertise",
  "insights",
  "careers",
  "contact",
  // "project/four-seasons-resort-nevis",
  // "project/el-portal-tropical-rainforest-center",
];

// const translate = () => {
// langlist.forEach((lang) => {
//   pagelist.forEach((page) => {
//     const userAction = async () => {
//       const response = await fetch(
//         location.protocol + '//' + location.hostname + "/" + page,

//       ).then(function (response) {
//         // The API call was successful!
//         return response.text();
//       }).then(function (html) {

//         // Convert the HTML string into a document object
//         var parser = new DOMParser();
//         var doc = parser.parseFromString(html, 'text/html');

//         let tempsplide = [];

//         doc.querySelectorAll(".splide-slider").forEach((elem, i) => {
//           elem.dataset.splideid = i;

//           tempsplide[i] = new Splide(elem, {
//             type: "loop",
//             perPage: 1,
//             autoplay: true,
//             pauseOnHover: false,
//             pauseOnFocus: false,
//             interval: "7000",
//             speed: "800",
//           });

//           tempsplide[i].on("mounted", function () {});
//           tempsplide[i].mount();
//         });

//         splitLines(doc.querySelectorAll(".fs-85, .indent-text"));

//         setTimeout(() => {

//           console.log(doc);

//         const langData = cloudTranslate.screen(
//           doc.querySelectorAll("[translate] *")
//         );

//         cloudTranslate.init(
//           lang,
//           langData,
//           location.protocol + '//' + location.hostname + "/" + page
//         );
//       }, 40);

//       }).catch(function (err) {
//         // There was an error
//         console.warn('Something went wrong.', err);
//       });

//     };

//     userAction();
//   });
// });

// };

//translate();

// foreach ($langlist as $lang) {
//     foreach ($pagelist as $page) {
//         $break = preg_replace('/[\W\s\/]+/', '', $page);
//         $cachefile = '../../langcache/cached-' . $break . '-' . $lang . '.json';
//         file_put_contents($cachefile, json_encode($result));
//     }
// }
